import React from 'react';
import styles from './styles.module.scss';
import withTheme from '../shared/progressIndicators/withTheme';

export const ProgressDonut = ({
  completed,
  total,
  size,
  strokeWidth,
  completedColor,
}) => {
  const completion = 100 * completed / total;
  const halfsize = size * 0.5;
  const radius = halfsize - strokeWidth * 0.5;
  const circumference = 2 * Math.PI * radius;
  const strokeval = completion * circumference / 100;
  const dashval = strokeval + ' ' + circumference;
  const trackstyle = { strokeWidth: strokeWidth };
  const indicatorstyle = {
    strokeWidth: strokeWidth,
    strokeDasharray: dashval,
    stroke: completedColor,
  };
  const rotateval = 'rotate(-90 ' + halfsize + ',' + halfsize + ')';

  return (
    <svg width={size} height={size} className={styles.donutchart}>
      <circle
        r={radius}
        cx={halfsize}
        cy={halfsize}
        transform={rotateval}
        style={trackstyle}
        className={styles.donutchartTrack}
      />
      <circle
        r={radius}
        cx={halfsize}
        cy={halfsize}
        transform={rotateval}
        style={indicatorstyle}
        className={styles.donutchartIndicator}
      />
    </svg>
  );
};

export default withTheme(ProgressDonut);
